import React, { useEffect, useState, useRef } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import Select from 'react-select';
import Cookies from 'js-cookie';
import { useAddUser } from '../../API_Master/MutateAPI'; // ← create this hook similar to useAddVenderRegistration
import { useAreaData, useCityData, usePoliceStationData, useUserData, useZoneData } from '../../API_Master/GetAPI';
import { notifyError, notifySuccess } from '../../HelperMethods';
import { useDispatch, useSelector } from 'react-redux';
import { handleEditUserID } from '../../Redux/Slices/ProjectSlice';
import { useNavigate } from 'react-router-dom';
import { mainRouteInitial } from '../../Data/Constant';

const AddUserForm = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const fileInputRef = useRef(null);
    const { mutate: addUser, isPending: addingUser } = useAddUser();
    const { editUserID } = useSelector(state => state.ProjectSlice)
    const { data: zoneData = [] } = useZoneData(null, Cookies.get("NIGHT_EYE_ZONE_ID"));
    const { data: cityData = [] } = useCityData(Cookies.get("NIGHT_EYE_CITY_ID"));
    const { data: policeStationData = [] } = usePoliceStationData(null, null, Cookies.get("NIGHT_EYE_POLICE_STATION_ID"));
    const { data: areaData = [] } = useAreaData();
    const { data: userData = [] } = useUserData(editUserID)
    console.log(userData, "sdfksdjfksjdkjf")

    // Replace with real data from your APIs
    const cityOptions = cityData?.map((ele) => ({
        value: ele?.CityID,
        label: ele?.CityName
    }))

    const zoneOptions = zoneData?.map((ele) => ({
        value: ele?.ZoneID,
        label: ele?.ZoneName,
    }))

    const policeStationOptions = policeStationData?.map((ele) => ({
        value: ele?.PoliceStationID,
        label: ele?.PoliceStation,
    }));

    const areaOptions = areaData?.map((ele) => ({
        value: ele?.AreaID,
        label: ele?.AreaName,
    }));

    // `formikReady` flips true once userData has loaded and Formik has been
    // re-initialized. Before that, we filter using raw userData IDs to cover
    // the first-render timing gap. After that, we rely purely on live
    // Formik `values` so user deselections correctly re-add items to the list.
    const [formikReady, setFormikReady] = useState(false);

    useEffect(() => {
        if (userData?.length > 0) {
            // Small timeout to let Formik finish re-initialization before we switch
            const t = setTimeout(() => setFormikReady(true), 50);
            return () => clearTimeout(t);
        } else {
            setFormikReady(false);
        }
    }, [userData]);

    // Raw ID sets — only used during the pre-ready phase to filter options before
    // Formik values are populated. Once formikReady, these are ignored.
    const rawSelectedCityIDs = new Set(
        (userData?.[0]?.UserCityDetail || []).map(ele => String(ele?.CityID))
    );
    const rawSelectedZoneIDs = new Set(
        (userData?.[0]?.UserZoneDetail || []).map(ele => String(ele?.ZoneID))
    );
    const rawSelectedPoliceStationIDs = new Set(
        (userData?.[0]?.UserPoliceStationDetail || []).map(ele => String(ele?.PoliceStationID))
    );
    const rawSelectedAreaIDs = new Set(
        (userData?.[0]?.UserAreaDetail || []).map(ele => String(ele?.AreaID))
    );

    const initialValues = {
        UserRole: userData?.[0]?.UserRoleDetail?.[0]?.UserRole || '',
        Name: userData?.[0]?.Name || '',
        UserID: userData?.[0]?.UserID || '',
        MobileNo: userData?.[0]?.MobileNo || '',
        UserName: userData?.[0]?.UserName || '',
        Password: userData?.[0]?.Password || '',
        Address: userData?.[0]?.Address || '',
        UserImage: null,
        OldUserImage: userData?.[0]?.UserImage || '',
        CityDetail: userData?.[0]?.UserCityDetail?.map(ele => ({
            value: ele?.CityID,
            label: ele?.CityName
        })) || [],
        ZoneDetail: userData?.[0]?.UserZoneDetail?.map(ele => ({
            value: ele?.ZoneID,
            label: ele?.ZoneName,
        })) || [],
        PoliceStationDetail: userData?.[0]?.UserPoliceStationDetail?.map(ele => ({
            value: ele?.PoliceStationID,
            label: ele?.PoliceStation,
        })) || [],
        AreaDetail: userData?.[0]?.UserAreaDetail?.map(ele => ({
            value: ele?.AreaID,
            label: ele?.AreaName,
        })) || [],
    };

    console.log(initialValues, "sdjhfjskf")

    const validationSchema = Yup.object({
        UserRole: Yup.string().required('User Role is required'),
        Name: Yup.string()
            .required('Name is required')
            .min(2, 'Name must be at least 2 characters')
            .max(100, 'Name is too long'),
        MobileNo: Yup.string()
            .required('Mobile Number is required')
            .matches(/^[6-9]\d{9}$/, 'Enter valid 10-digit Indian mobile number'),
        UserName: Yup.string()
            .required('Username is required')
            .min(4, 'Username must be at least 4 characters'),
        Password: Yup.string()
            .required('Password is required')
            .min(8, 'Password must be at least 8 characters')
            .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
            .matches(/[0-9]/, 'Password must contain at least one number')
            .matches(/[@$!%*?&]/, 'Password must contain at least one special character (@$!%*?&)'),
        Address: Yup.string().nullable(),
        CityDetail: Yup.array().min(1, 'At least one City is required'),
        ZoneDetail: Yup.array().min(1, 'At least one Zone is required'),
        PoliceStationDetail: Yup.array().nullable(),
        AreaDetail: Yup.array().nullable(),
        UserImage: Yup.mixed().when('OldUserImage', {
            is: (old) => !old || old.trim() === '',
            then: (schema) =>
                schema
                    .required('User image is required')
                    .test('fileSize', 'File too large (max 5MB)', (value) => !value || value.size <= 5000000)
                    .test('fileType', 'Only JPG, jpeg, PNG allowed', (value) =>
                        !value || ['image/jpeg', 'image/jpg', 'image/png'].includes(value.type)
                    ),
            otherwise: (schema) => schema.nullable(),
        }),
    });

    const inputBaseClasses = 'w-full h-12 px-4 rounded-lg bg-slate-50 dark:bg-slate-800 text-[#0d141b] dark:text-white placeholder:text-slate-400 transition-all outline-none';
    const inputFocusClasses = 'focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500';
    const inputErrorClasses = 'border-red-500';
    const inputNormalBorder = 'border border-slate-300 dark:border-slate-600';

    const selectStyles = {
        control: (provided, state) => ({
            ...provided,
            height: 'auto',
            minHeight: '48px',
            backgroundColor: 'rgb(241 245 249)',
            borderColor: state.isFocused ? '#3B82F6' : 'rgb(203 213 225)',
            boxShadow: state.isFocused ? '0 0 0 1px #3B82F6' : 'none',
            borderRadius: '0.5rem',
            '&:hover': { borderColor: '#3B82F6' },
        }),
        valueContainer: (provided) => ({ ...provided, padding: '0 8px', flexWrap: 'wrap' }),
        singleValue: (provided) => ({ ...provided, color: '#0D141B' }),
        multiValue: (provided) => ({ ...provided, backgroundColor: '#DBEAFE', borderRadius: '4px' }),
        multiValueLabel: (provided) => ({ ...provided, color: '#1E40AF' }),
        multiValueRemove: (provided) => ({
            ...provided,
            color: '#1E40AF',
            ':hover': { backgroundColor: '#BFDBFE', color: '#1E3A8A' },
        }),
        placeholder: (provided) => ({ ...provided, color: '#94A3B8' }),
    };

    const darkSelectStyles = {
        ...selectStyles,
        control: (provided, state) => ({
            ...provided,
            backgroundColor: '#1E293B',
            borderColor: state.isFocused ? '#3B82F6' : '#334155',
            '&:hover': { borderColor: '#3B82F6' },
        }),
        singleValue: (provided) => ({ ...provided, color: '#F8FAFC' }),
        multiValue: (provided) => ({ ...provided, backgroundColor: '#1E40AF' }),
        multiValueLabel: (provided) => ({ ...provided, color: '#F3F4F6' }),
        multiValueRemove: (provided) => ({
            ...provided,
            color: '#F3F4F6',
            ':hover': { backgroundColor: '#2563EB', color: '#FFFFFF' },
        }),
    };


    useEffect(() => {
        return () => {
            dispatch(handleEditUserID(null))
        }
    }, [])
    return (
        <>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                enableReinitialize={true}
                onSubmit={(values, { setSubmitting, resetForm }) => {

                    const formData = new FormData();

                    formData.append('UserID', values?.UserID || '');
                    formData.append('UserRole', values?.UserRole || '');
                    formData.append('Name', values?.Name || '');
                    formData.append('MobileNo', values?.MobileNo || '');
                    formData.append('UserName', values?.UserName || '');
                    formData.append('Password', values?.Password || '');
                    formData.append('Address', values?.Address || '');
                    formData.append('OldUserImage', values?.OldUserImage || '');

                    // Multi-select → JSON string arrays
                    formData.append('CityDetail', values?.CityDetail?.length ? JSON.stringify(values?.CityDetail?.map(item => ({ CityID: item.value }))) : []);
                    formData.append('ZoneDetail', values?.ZoneDetail?.length ? JSON.stringify(values?.ZoneDetail?.map(item => ({ ZoneID: item.value }))) : []);
                    formData.append('PoliceStationDetail', values?.PoliceStationDetail?.length ? JSON.stringify(values?.PoliceStationDetail.map(item => ({ PoliceStationID: item.value }))) : []);
                    formData.append('AreaDetail', values?.AreaDetail?.length ? JSON.stringify(values?.AreaDetail?.map(item => ({ AreaID: item.value }))) : []);

                    formData.append('CreatedByUserID', Cookies.get('NIGHT_EYE_USER_ID') || '');
                    formData.append('UpdatedByUserID', Cookies.get('NIGHT_EYE_USER_ID') || '');

                    if (values?.UserImage) {
                        formData.append('UserImage', values?.UserImage);
                    }

                    addUser(formData, {
                        onSuccess: (res) => {
                            if (res?.status === true) {
                                if (editUserID) {
                                    notifySuccess('User updated successfully');
                                    resetForm();
                                    if (fileInputRef.current) fileInputRef.current.value = '';
                                    navigate(`/${mainRouteInitial}/viewUser`)
                                } else {
                                    notifySuccess('User created successfully');
                                    resetForm();
                                    if (fileInputRef.current) fileInputRef.current.value = '';
                                }

                            } else {
                                notifyError(res?.message || 'Failed to create user');
                            }
                            setSubmitting(false);
                        },
                        onError: () => {

                            notifyError('Failed to create user');
                            setSubmitting(false);
                        },
                    });
                }}
            >
                {({ values, touched, errors, setFieldValue, handleBlur, isSubmitting, resetForm }) => (
                    <Form className="bg-white dark:bg-[#1A2633] rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 overflow-hidden">
                        <div className="p-6 md:p-8 border-b border-slate-100 dark:border-slate-700">
                            <h3 className="text-xl font-bold mb-6 text-gray-900 dark:text-white">Add New User</h3>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                                {/* Name */}
                                <div className="flex flex-col gap-2">
                                    <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
                                        User Role <span className="text-red-600">*</span>
                                    </label>
                                    <input
                                        name="UserRole"
                                        value={values.UserRole}
                                        onChange={(e) => setFieldValue('UserRole', e.target.value)}
                                        onBlur={handleBlur}
                                        className={`${inputBaseClasses} ${inputFocusClasses} ${touched.UserRole && errors.UserRole ? inputErrorClasses : inputNormalBorder}`}
                                        placeholder="User Role"
                                    />
                                    {touched.UserRole && errors.UserRole && <p className="text-red-600 text-sm">{errors.UserRole}</p>}
                                </div>


                                {/* Name */}
                                <div className="flex flex-col gap-2">
                                    <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
                                        Name <span className="text-red-600">*</span>
                                    </label>
                                    <input
                                        name="Name"
                                        value={values.Name}
                                        onChange={(e) => setFieldValue('Name', e.target.value)}
                                        onBlur={handleBlur}
                                        className={`${inputBaseClasses} ${inputFocusClasses} ${touched.Name && errors.Name ? inputErrorClasses : inputNormalBorder}`}
                                        placeholder="Full name"
                                    />
                                    {touched.Name && errors.Name && <p className="text-red-600 text-sm">{errors.Name}</p>}
                                </div>

                                {/* Mobile No */}
                                <div className="flex flex-col gap-2">
                                    <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
                                        Mobile Number <span className="text-red-600">*</span>
                                    </label>
                                    <input
                                        name="MobileNo"
                                        value={values.MobileNo}
                                        maxLength={10}
                                        onChange={(e) => {
                                            const val = e.target.value.replace(/\D/g, '');
                                            setFieldValue('MobileNo', val);
                                        }}
                                        onBlur={handleBlur}
                                        className={`${inputBaseClasses} ${inputFocusClasses} ${touched.MobileNo && errors.MobileNo ? inputErrorClasses : inputNormalBorder}`}
                                        placeholder="10-digit mobile number"
                                    />
                                    {touched.MobileNo && errors.MobileNo && <p className="text-red-600 text-sm">{errors.MobileNo}</p>}
                                </div>

                                {/* Username */}
                                <div className="flex flex-col gap-2">
                                    <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
                                        Username <span className="text-red-600">*</span>
                                    </label>
                                    <input
                                        name="UserName"
                                        value={values.UserName}
                                        autoComplete="off"
                                        onChange={(e) => setFieldValue('UserName', e.target.value)}
                                        onBlur={handleBlur}
                                        className={`${inputBaseClasses} ${inputFocusClasses} ${touched.UserName && errors.UserName ? inputErrorClasses : inputNormalBorder}`}
                                        placeholder="Username"
                                    />
                                    {touched.UserName && errors.UserName && <p className="text-red-600 text-sm">{errors.UserName}</p>}
                                </div>

                                {/* Password */}
                                <div className="flex flex-col gap-2">
                                    <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
                                        Password <span className="text-red-600">*</span>
                                    </label>
                                    <input
                                        name="Password"
                                        type="password"
                                        autoComplete="new-password"
                                        value={values.Password}
                                        onChange={(e) => setFieldValue('Password', e.target.value)}
                                        onBlur={handleBlur}
                                        className={`${inputBaseClasses} ${inputFocusClasses} ${touched.Password && errors.Password ? inputErrorClasses : inputNormalBorder}`}
                                        placeholder="Strong password"
                                    />
                                    {touched.Password && errors.Password && <p className="text-red-600 text-sm">{errors.Password}</p>}
                                </div>

                                {/* Address */}
                                <div className="flex flex-col gap-2 md:col-span-2">
                                    <label className="text-sm font-medium text-gray-700 dark:text-gray-300">Address</label>
                                    <textarea
                                        name="Address"
                                        value={values.Address}
                                        onChange={(e) => setFieldValue('Address', e.target.value)}
                                        rows={3}
                                        className={`${inputBaseClasses} ${inputFocusClasses} ${inputNormalBorder} resize-y pt-3`}
                                        placeholder="Full address (optional)"
                                    />
                                </div>

                                {/* City - Multi */}
                                <div className="flex flex-col gap-2">
                                    <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
                                        City <span className="text-red-600">*</span>
                                    </label>
                                    <Select
                                        isMulti
                                        options={cityOptions?.filter(opt => {
                                            const id = String(opt.value);
                                            return formikReady || !editUserID
                                                ? !values.CityDetail?.some(s => String(s.value) === id)
                                                : !rawSelectedCityIDs.has(id);
                                        })}
                                        value={values.CityDetail}
                                        onChange={(selected) => {
                                            setFieldValue('CityDetail', selected || []);
                                            if (!selected?.length) {
                                                setFieldValue('ZoneDetail', []);
                                                setFieldValue('PoliceStationDetail', []);
                                                setFieldValue('AreaDetail', []);
                                            }
                                        }}
                                        placeholder="Select one or more cities"
                                        styles={document.body.classList.contains('dark') ? darkSelectStyles : selectStyles}
                                        classNamePrefix="react-select"
                                    />
                                    {touched.CityDetail && errors.CityDetail && (
                                        <p className="text-red-600 text-sm">{errors.CityDetail}</p>
                                    )}
                                </div>

                                {/* Zone - Multi */}
                                <div className="flex flex-col gap-2">
                                    <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
                                        Zone <span className="text-red-600">*</span>
                                    </label>
                                    <Select
                                        isMulti
                                        options={zoneOptions?.filter(opt => {
                                            const id = String(opt.value);
                                            return formikReady || !editUserID
                                                ? !values.ZoneDetail?.some(s => String(s.value) === id)
                                                : !rawSelectedZoneIDs.has(id);
                                        })}
                                        value={values.ZoneDetail}
                                        isDisabled={!values.CityDetail?.length}
                                        onChange={(selected) => {
                                            setFieldValue('ZoneDetail', selected || []);
                                            if (!selected?.length) {
                                                setFieldValue('PoliceStationDetail', []);
                                                setFieldValue('AreaDetail', []);
                                            }
                                        }}
                                        placeholder={!values.CityDetail?.length ? 'Select a city first' : 'Select one or more zones'}
                                        styles={document.body.classList.contains('dark') ? darkSelectStyles : selectStyles}
                                        classNamePrefix="react-select"
                                    />
                                    {touched.ZoneDetail && errors.ZoneDetail && (
                                        <p className="text-red-600 text-sm">{errors.ZoneDetail}</p>
                                    )}
                                </div>

                                {/* Police Station - Multi */}
                                <div className="flex flex-col gap-2">
                                    <label className="text-sm font-medium text-gray-700 dark:text-gray-300">Police Station</label>
                                    <Select
                                        isMulti
                                        options={policeStationOptions?.filter(opt => {
                                            const id = String(opt.value);
                                            return formikReady || !editUserID
                                                ? !values.PoliceStationDetail?.some(s => String(s.value) === id)
                                                : !rawSelectedPoliceStationIDs.has(id);
                                        })}
                                        value={values.PoliceStationDetail}
                                        isDisabled={!values.ZoneDetail?.length}
                                        onChange={(selected) => {
                                            setFieldValue('PoliceStationDetail', selected || []);
                                            if (!selected?.length) {
                                                setFieldValue('AreaDetail', []);
                                            }
                                        }}
                                        placeholder={!values.ZoneDetail?.length ? 'Select a zone first' : 'Select police stations (optional)'}
                                        isClearable
                                        styles={document.body.classList.contains('dark') ? darkSelectStyles : selectStyles}
                                        classNamePrefix="react-select"
                                    />
                                </div>

                                {/* Area - Multi */}
                                <div className="flex flex-col gap-2">
                                    <label className="text-sm font-medium text-gray-700 dark:text-gray-300">Area</label>
                                    <Select
                                        isMulti
                                        options={areaOptions?.filter(opt => {
                                            const id = String(opt.value);
                                            return formikReady || !editUserID
                                                ? !values.AreaDetail?.some(s => String(s.value) === id)
                                                : !rawSelectedAreaIDs.has(id);
                                        })}
                                        value={values.AreaDetail}
                                        isDisabled={!values.PoliceStationDetail?.length}
                                        onChange={(selected) => setFieldValue('AreaDetail', selected || [])}
                                        placeholder={!values.PoliceStationDetail?.length ? 'Select a police station first' : 'Select areas (optional)'}
                                        isClearable
                                        styles={document.body.classList.contains('dark') ? darkSelectStyles : selectStyles}
                                        classNamePrefix="react-select"
                                    />
                                </div>

                                {/* Image Upload */}
                                <div className="flex flex-col gap-2 md:col-span-2">
                                    <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
                                        User Photo {values.OldUserImage ? '(optional)' : <span className="text-red-600">*</span>}
                                    </label>
                                    <input
                                        ref={fileInputRef}
                                        type="file"
                                        accept="image/jpeg,image/jpg,image/png"
                                        onChange={(e) => {
                                            const file = e.target.files?.[0];
                                            if (file) setFieldValue('UserImage', file);
                                        }}
                                        className="block w-full text-sm text-slate-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100 dark:file:bg-slate-700 dark:file:text-slate-200 dark:file:hover:bg-slate-600"
                                    />
                                    {touched.UserImage && errors.UserImage && (
                                        <p className="text-red-600 text-sm">{errors.UserImage}</p>
                                    )}
                                    {values.OldUserImage && (
                                        <p className="text-sm text-gray-500">Existing image: {values.OldUserImage}</p>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* Submit / Clear */}
                        <div className="p-6 md:p-8 border-t border-slate-200 dark:border-slate-700 flex justify-end gap-3">
                            <button
                                type="button"
                                onClick={() => {
                                    resetForm();
                                    dispatch(handleEditUserID(null));
                                    setFormikReady(false);
                                    if (fileInputRef.current) fileInputRef.current.value = '';
                                }}
                                className="px-8 py-3 bg-slate-100 dark:bg-slate-700 text-slate-700 dark:text-slate-200 font-medium rounded-lg hover:bg-slate-200 dark:hover:bg-slate-600 transition-colors"
                            >
                                Clear
                            </button>
                            <button
                                type="submit"
                                disabled={addingUser || isSubmitting}
                                className="px-8 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center gap-2"
                            >
                                {editUserID ? (addingUser ? 'Updating...' : 'Update User') : (addingUser ? 'Creating...' : 'Create User')}
                            </button>
                        </div>
                    </Form>
                )}
            </Formik>

        </>
    );
};

export default AddUserForm;